import { render } from "./WalletsOption.vue?vue&type=template&id=9d500878"
import script from "./WalletsOption.vue?vue&type=script&lang=js"
export * from "./WalletsOption.vue?vue&type=script&lang=js"

import "./WalletsOption.vue?vue&type=style&index=0&id=9d500878&lang=css"

import exportComponent from "F:\\ssd_backup\\OpenServer\\domains\\paygate.admin-panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__